import { CompositeMergeResponseDto, CompositeProjectMetadataDto, PageContextOfProjectDataFilter, VariableDto, VariablesFilterOptionsDto } from "app/ApiClient";
import { ProjectDataTableConfig} from 'const/projectVariables';
import { DEFAULT_BATTERIES } from "slices/batteries/batteriesState";
import { LoadingState } from "types";

import { BaseState } from "..";

export const initialPageContext: PageContextOfProjectDataFilter = {
  filter: {
    batteries: DEFAULT_BATTERIES,
  },
  page: {
    pageSize: ProjectDataTableConfig.DefaultPageSize,
    pageNumber: 1,
  },
};

export default interface DatasetsState extends BaseState {
  activeVariableTabView: string,
  compoisteProjectMergeStatus: LoadingState, 
  compositeProjectLoadingState: LoadingState,
  compositeProjectMergeResponse: CompositeMergeResponseDto | null,
  compositeProjectMetadata: CompositeProjectMetadataDto| null;
  currentModificationId: number | null;
  currentStackId: number | null;
  currentVariable: VariableDto | null;
  currentVersionId: string | null;
  excludedVariables: VariableDto[],
  hiddenColumns: string[];
  includedVariables: VariableDto[],
  includedVariablesSelectedAll: boolean,
  isGenerateDictionaryDataDialogOpened: boolean;
  includePageContext: PageContextOfProjectDataFilter;
  excludePageContext: PageContextOfProjectDataFilter;
  preSelectedExcludedVariables:VariableDto[],
  preSelectedIncludedVariables:VariableDto[],
  resetFilters?: boolean;
  respondentsCount: number;
  respondentsCountLoading:boolean;
  respondentsErrorMessage?: string;
  selectedExcludedVariables:VariableDto[],
  selectedIncludedVariables:VariableDto[],
  showLoadingError: boolean;
  tableFiltersOptions: VariablesFilterOptionsDto[];
  tableFiltersOptionsLoading: LoadingState;
  totalIncludedVariablesCount: number;
  totalIncludedVariablesCountWithoutFilter: number;
  totalExcludedVariablesCount: number;
  totalExcludedVariablesCountWithoutFilter: number;
  updateVariableLoadingError?: string;
  updateVariableLoadingState?: LoadingState;
  variableSearchString: string;
  showIncludedAlertMessage: boolean;
  showExcludedAlertMessage: boolean;
  includedTabChipText: string;
  excludedTabChipText: string;
}

export const originDatasetsState: DatasetsState = {
  activeVariableTabView: "IncludedVariableTab",
  compoisteProjectMergeStatus: LoadingState.idle, 
  compositeProjectLoadingState: LoadingState.idle,
  compositeProjectMergeResponse : null,
  compositeProjectMetadata : null,
  currentModificationId: null,
  currentStackId: null,
  currentVariable: null,
  currentVersionId: null,
  error: "",
  excludedVariables:[],
  failed: false,
  finished: false,
  hiddenColumns: [],
  includedVariables: [],
  includedVariablesSelectedAll: false,
  isGenerateDictionaryDataDialogOpened: false,
  includePageContext: initialPageContext,
  excludePageContext: initialPageContext,
  preSelectedExcludedVariables:[],
  preSelectedIncludedVariables:[],
  processing: false,
  resetFilters: false,
  respondentsCount: 0,
  respondentsCountLoading:false,
  selectedExcludedVariables:[],
  selectedIncludedVariables:[],
  showLoadingError: false,
  succeed: false,
  tableFiltersOptions: [],
  tableFiltersOptionsLoading: LoadingState.idle,
  totalIncludedVariablesCount: 0,
  totalIncludedVariablesCountWithoutFilter: 0,
  totalExcludedVariablesCount: 0,
  totalExcludedVariablesCountWithoutFilter: 0,
  variableSearchString:"",
  showIncludedAlertMessage: false,
  showExcludedAlertMessage: false,
  includedTabChipText: "",
  excludedTabChipText: "",
};
